module.exports = __webpack_public_path__ + "static/media/docc.41175107.svg";